'use client';

import { useEffect, useCallback, useMemo, useState } from 'react';
import { useCentrifugo } from '../contexts/CentrifugoContext';
import { numberField } from '../lib/jsonBody';

const CHANNEL_SUFFIX = 'online_count';

const getChannel = (prefix: string): string => {
  return prefix ? `${prefix}_${CHANNEL_SUFFIX}` : CHANNEL_SUFFIX;
};

export const useOnlineCountSubscription = () => {
  const { subscribe, isConnected, channelPrefix } = useCentrifugo();
  const [onlineCount, setOnlineCount] = useState<number | null>(null);

  const channelName = useMemo(
    () => getChannel(channelPrefix),
    [channelPrefix],
  );

  const handleUpdate = useCallback(
    (data: unknown) => {
      const online = numberField(data, 'online');
      if (online !== undefined) {
        setOnlineCount(online);
      }
    },
    [],
  );

  useEffect(() => {
    if (!isConnected) return;

    const unsubscribe = subscribe(channelName, handleUpdate);

    return unsubscribe;
  }, [isConnected, channelName, subscribe, handleUpdate]);

  return onlineCount;
};
